import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function KitProDetails() {
  const comparison = [{
    sit: 'Necesito calificar leads rápido',
    sin: 'Revisás uno por uno manualmente',
    con: 'Sistema de scoring automático. 30 segundos.'
  }, {
    sit: 'Tengo que hacer una propuesta hoy',
    sin: 'Tardás 4-8 horas en armarla',
    con: 'Propuesta lista en 15 minutos con estructura probada'
  }, {
    sit: 'El cliente está molesto y no sé cómo responder',
    sin: 'Improvisás bajo presión',
    con: 'Protocolo de respuesta inteligente. Ya está hecho.'
  }, {
    sit: 'Necesito contenido para todo el mes',
    sin: 'Dedicás 20 horas o no publicás',
    con: 'Fábrica de contenido mensual en 2 horas'
  }, {
    sit: 'Tengo que presentar un reporte financiero',
    sin: 'Lo armás el domingo a la noche',
    con: 'Dashboard financiero semanal automatizado'
  }, {
    sit: 'Quiero contratar pero no sé cómo evaluar CVs',
    sin: 'Gut feeling sin criterio',
    con: 'Sistema de reclutamiento con scoring objetivo'
  }];
  const includes = [{
    title: '50 Workflows listos',
    desc: 'Para 6 departamentos: Ventas, Atención al Cliente, Marketing, Operaciones, Finanzas y RRHH'
  }, {
    title: 'Framework de 3 Capas',
    desc: 'Datos → Razonamiento → Salida. La arquitectura que hace funcionar cualquier sistema de IA'
  }, {
    title: 'Protocolo HITL',
    desc: 'Sistema de Cajas Verde/Amarilla/Roja para delegar sin perder el control'
  }, {
    title: 'Directorio de herramientas 2026',
    desc: 'Las mejores herramientas por categoría con precio y cuándo usar cada una'
  }, {
    title: 'Plan de implementación 4 semanas',
    desc: 'Día a día para instalar el sistema sin caos'
  }, {
    title: 'Métricas por departamento',
    desc: 'Qué medir para saber si el sistema está funcionando'
  }, {
    title: 'Plantillas de personalización',
    desc: 'Fichas de contexto listas para adaptar cada workflow a tu negocio'
  }, {
    title: 'Plan de escalamiento 12 meses',
    desc: 'De usuario individual a sistema empresarial semi-autónomo'
  }];
  return <section className="py-20 px-4 bg-surface/30" data-id="element-164">
      <div className="max-w-5xl mx-auto" data-id="element-165">
        <div className="text-center mb-12" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-167">
            🖥️ ¿QUÉ AGREGA EL "AI OS: SISTEMA OPERATIVO DE NEGOCIOS"?
          </h2>
        </div>

        <div className="overflow-x-auto mb-16 hide-scrollbar" data-id="element-168">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-169">
            <thead data-id="element-170">
              <tr className="border-b border-border" data-id="element-171">
                <th className="text-left py-4 px-6 text-muted font-medium w-1/3" data-id="element-172">
                  Situación en tu negocio
                </th>
                <th className="text-left py-4 px-6 text-danger font-medium w-1/3" data-id="element-173">
                  ❌ Sin AI OS
                </th>
                <th className="text-left py-4 px-6 text-accent font-medium w-1/3" data-id="element-174">
                  ✅ Con AI OS
                </th>
              </tr>
            </thead>
            <tbody data-id="element-175">
              {comparison.map((row, idx) => <tr key={idx} className="border-b border-border/50 hover:bg-surface/50 transition-colors" data-id="element-176">
                  <td className="py-4 px-6 text-white font-medium" data-id="element-177">
                    {row.sit}
                  </td>
                  <td className="py-4 px-6 text-gray-400" data-id="element-178">{row.sin}</td>
                  <td className="py-4 px-6 text-accent font-medium" data-id="element-179">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-surface border border-accent/30 rounded-2xl p-8 md:p-12" data-id="element-180">
          <h3 className="text-2xl font-heading font-bold text-white mb-8 text-center" data-id="element-181">
            ✅ EL AI OS INCLUYE:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-182">
            {includes.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-183">
                <CheckCircle2 className="text-accent shrink-0 mt-1" size={20} data-id="element-184" />
                <div data-id="element-185">
                  <div className="font-bold text-white mb-1" data-id="element-186">{item.title}</div>
                  <div className="text-sm text-gray-400" data-id="element-187">{item.desc}</div>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}